"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.preReleaseNumber = exports.preReleaseLabel = exports.patch = exports.minor = exports.major = exports.default = void 0;
const version = exports.version = "5.16.14";
const major = exports.major = Number("5");
const minor = exports.minor = Number("16");
const patch = exports.patch = Number("14");
const preReleaseLabel = exports.preReleaseLabel = undefined || null;
const preReleaseNumber = exports.preReleaseNumber = Number(undefined) || null;
var _default = exports.default = version;